export const reportSectionsConf = {
  exome_fastq: {
    visible: true,
    name: "exome_fastq",
    label: "Exome (Fastq)",
    tabs: {
      statistics: {
        name: "statistics",
        label: "Statistics",
        order: 0,
        component: "",
      },
      variant_table: {
        name: "variant_table",
        label: "Variant table",
        order: 1,
        component: "",
      },
      cnv: {
        name: "cnv",
        label: "CNV",
        order: 2,
        component: "",
      },
      massive_insight: {
        name: "massive_insight",
        label: "MASSIVE INSIGHT",
        order: 3,
        component: "",
        selectable: false,
      },
    },
    detailsTabs: {
      main: {
        name: "main",
        label: "Main details",
        order: 0,
        component: "",
      },
      pathogenicity: {
        name: "pathogenicity",
        label: "Pathogenicity scores",
        order: 1,
        component: "",
      },
      population_conservation: {
        name: "population_conservation",
        label: "Population frequencies and conservation scores",
        order: 2,
        component: "",
      },
      external: {
        name: "external",
        label: "External databases (ClinVar, COSMIC, Phenotype)",
        order: 3,
        component: "",
      },
      phenotype_information: {
        name: "phenotype_information",
        label: "Phenotype Databases (ClinGen, Gene2Pheno, Orphanet)",
        order: 3,
        component: "",
      },
      biomarker: {
        name: "biomarker",
        label: "Biomarker",
        order: 4,
        component: "",
      },
      comment: {
        name: "comments",
        label: "Comments",
        order: 5,
        component: "",
      },
      igv: {
        name: "igv",
        label: "Genome visualization",
        order: 6,
        component: "",
      },
      uniprot: {
        name: "main",
        label: "Uniprot",
        order: 7,
        component: "",
      },
      related_projects: {
        name: "main",
        label: "Related Projects",
        order: 8,
        component: "",
      },
      customize: {
        name: "main",
        label: "Customized Spesific Values",
        order: 8,
        component: "",
      },
    },
    charts: {
      v4: [
        "cnv_diagram_no_gender",
        "genomic_fraction_coverage",
        "chromosome_based_copy_ratio_no_treshold",
        "chromosome_mean_coverage",
        "mapping_quality_across_reference",
        "coverage_histogram",
        "indel_length",
        "transitions_and_transversions",
        "acgt_content",
        "insert_size_his",
        "mapped_reads_nucleotide_content",
        "mapped_reads_gc_content_disribution",
        "mapped_read_clipping_profile",
      ],
      v5: [
        "cnv_diagram_no_gender",
        "genomic_fraction_coverage",
        "chromosome_based_copy_ratio_no_treshold",
        "chromosome_mean_coverage",
        "mapping_quality_across_reference",
        "coverage_histogram",
        "indel_length",
        "transitions_and_transversions",
        "acgt_content",
        "insert_size_his",
        "mapped_reads_nucleotide_content",
        "mapped_reads_gc_content_disribution",
        "mapped_read_clipping_profile",
      ],
      v6: [
        "cnv_diagram_no_gender",
        "genomic_fraction_coverage",
        "chromosome_based_copy_ratio_no_treshold",
        "chromosome_mean_coverage",
        "mapping_quality_across_reference",
        "coverage_histogram",
        "indel_length",
        "transitions_and_transversions",
        "acgt_content",
        "insert_size_his",
        "mapped_reads_nucleotide_content",
        "mapped_reads_gc_content_disribution",
        "mapped_read_clipping_profile",
      ],
      v7: [
        "cnv_diagram_no_gender",
        "genomic_fraction_coverage",
        "chromosome_based_copy_ratio_no_treshold",
        "chromosome_mean_coverage",
        "mapping_quality_across_reference",
        "coverage_histogram",
        "indel_length",
        "transitions_and_transversions",
        "acgt_content",
        "insert_size_his",
        "mapped_reads_nucleotide_content",
        "mapped_reads_gc_content_disribution",
        "mapped_read_clipping_profile",
      ],
      v8: [
        "cnv_diagram_no_gender",
        "genomic_fraction_coverage",
        "chromosome_based_copy_ratio_no_treshold",
        "chromosome_mean_coverage",
        "mapping_quality_across_reference",
        "coverage_histogram",
        "indel_length",
        "transitions_and_transversions",
        "acgt_content",
        "insert_size_his",
        "mapped_reads_nucleotide_content",
        "mapped_reads_gc_content_disribution",
        "mapped_read_clipping_profile",
      ],
      v9: [
        "cnv_diagram_no_gender",
        "genomic_fraction_coverage",
        "chromosome_based_copy_ratio_no_treshold",
        "chromosome_mean_coverage",
        "mapping_quality_across_reference",
        "coverage_histogram",
        "indel_length",
        "transitions_and_transversions",
        "acgt_content",
        "insert_size_his",
        "mapped_reads_nucleotide_content",
        "mapped_reads_gc_content_disribution",
        "mapped_read_clipping_profile",
      ],
      "v10/somatic": [
        "cnv_diagram_no_gender",
        "genomic_fraction_coverage",
        "chromosome_based_copy_ratio_no_treshold",
        "chromosome_mean_coverage",
        "mapping_quality_across_reference",
        "coverage_histogram",
        "indel_length",
        "transitions_and_transversions",
        "acgt_content",
        "insert_size_his",
        "mapped_reads_nucleotide_content",
        "mapped_reads_gc_content_disribution",
        "mapped_read_clipping_profile",
      ],
      v10: [
        "cnv_diagram_no_gender",
        "genomic_fraction_coverage",
        "chromosome_based_copy_ratio_no_treshold",
        "chromosome_mean_coverage",
        "mapping_quality_across_reference",
        "coverage_histogram",
        "indel_length",
        "transitions_and_transversions",
        "acgt_content",
        "insert_size_his",
        "mapped_reads_nucleotide_content",
        "mapped_reads_gc_content_disribution",
        "mapped_read_clipping_profile",
      ],
      v11: [
        "cnv_diagram_no_gender",
        "genomic_fraction_coverage",
        "chromosome_based_copy_ratio_no_treshold",
        "chromosome_mean_coverage",
        "mapping_quality_across_reference",
        "coverage_histogram",
        "indel_length",
        "transitions_and_transversions",
        "acgt_content",
        "insert_size_his",
        "mapped_reads_nucleotide_content",
        "mapped_reads_gc_content_disribution",
        "mapped_read_clipping_profile",
      ],
      "v11/somatic": [
        "cnv_diagram_no_gender",
        "genomic_fraction_coverage",
        "chromosome_based_copy_ratio_no_treshold",
        "chromosome_mean_coverage",
        "mapping_quality_across_reference",
        "coverage_histogram",
        "indel_length",
        "transitions_and_transversions",
        "acgt_content",
        "insert_size_his",
        "mapped_reads_nucleotide_content",
        "mapped_reads_gc_content_disribution",
        "mapped_read_clipping_profile",
      ],
      v12: [
        "cnv_diagram_no_gender",
        "genomic_fraction_coverage",
        "chromosome_based_copy_ratio_no_treshold",
        "chromosome_mean_coverage",
        "mapping_quality_across_reference",
        "coverage_histogram",
        "indel_length",
        "transitions_and_transversions",
        "acgt_content",
        "insert_size_his",
        "mapped_reads_nucleotide_content",
        "mapped_reads_gc_content_disribution",
        "mapped_read_clipping_profile",
      ],
      "v12/somatic": [
        "cnv_diagram_no_gender",
        "genomic_fraction_coverage",
        "chromosome_based_copy_ratio_no_treshold",
        "chromosome_mean_coverage",
        "mapping_quality_across_reference",
        "coverage_histogram",
        "indel_length",
        "transitions_and_transversions",
        "acgt_content",
        "insert_size_his",
        "mapped_reads_nucleotide_content",
        "mapped_reads_gc_content_disribution",
        "mapped_read_clipping_profile",
      ],
      v13: [
        "cnv_diagram_no_gender",
        "genomic_fraction_coverage",
        "chromosome_based_copy_ratio_no_treshold",
        "chromosome_mean_coverage",
        "mapping_quality_across_reference",
        "coverage_histogram",
        "indel_length",
        "transitions_and_transversions",
        "acgt_content",
        "insert_size_his",
        "mapped_reads_nucleotide_content",
        "mapped_reads_gc_content_disribution",
        "mapped_read_clipping_profile",
      ],
      "v13/somatic": [
        "cnv_diagram_no_gender",
        "genomic_fraction_coverage",
        "chromosome_based_copy_ratio_no_treshold",
        "chromosome_mean_coverage",
        "mapping_quality_across_reference",
        "coverage_histogram",
        "indel_length",
        "transitions_and_transversions",
        "acgt_content",
        "insert_size_his",
        "mapped_reads_nucleotide_content",
        "mapped_reads_gc_content_disribution",
        "mapped_read_clipping_profile",
      ],
      v14: [
        "cnv_diagram_no_gender",
        "genomic_fraction_coverage",
        "chromosome_based_copy_ratio_no_treshold",
        "chromosome_mean_coverage",
        "mapping_quality_across_reference",
        "coverage_histogram",
        "indel_length",
        "transitions_and_transversions",
        "acgt_content",
        "insert_size_his",
        "mapped_reads_nucleotide_content",
        "mapped_reads_gc_content_disribution",
        "mapped_read_clipping_profile",
      ],
      "v14/somatic": [
        "cnv_diagram_no_gender",
        "genomic_fraction_coverage",
        "chromosome_based_copy_ratio_no_treshold",
        "chromosome_mean_coverage",
        "mapping_quality_across_reference",
        "coverage_histogram",
        "indel_length",
        "transitions_and_transversions",
        "acgt_content",
        "insert_size_his",
        "mapped_reads_nucleotide_content",
        "mapped_reads_gc_content_disribution",
        "mapped_read_clipping_profile",
      ],
      v15: [
        "cnv_diagram_no_gender",
        "genomic_fraction_coverage",
        "chromosome_based_copy_ratio_no_treshold",
        "chromosome_mean_coverage",
        "mapping_quality_across_reference",
        "coverage_histogram",
        "indel_length",
        "transitions_and_transversions",
        "acgt_content",
        "insert_size_his",
        "mapped_reads_nucleotide_content",
        "mapped_reads_gc_content_disribution",
        "mapped_read_clipping_profile",
      ],
      "v15/somatic": [
        "cnv_diagram_no_gender",
        "genomic_fraction_coverage",
        "chromosome_based_copy_ratio_no_treshold",
        "chromosome_mean_coverage",
        "mapping_quality_across_reference",
        "coverage_histogram",
        "indel_length",
        "transitions_and_transversions",
        "acgt_content",
        "insert_size_his",
        "mapped_reads_nucleotide_content",
        "mapped_reads_gc_content_disribution",
        "mapped_read_clipping_profile",
      ],
      v16: [
        "cnv_diagram_no_gender",
        "genomic_fraction_coverage",
        "chromosome_based_copy_ratio_no_treshold",
        "chromosome_mean_coverage",
        "mapping_quality_across_reference",
        "coverage_histogram",
        "indel_length",
        "transitions_and_transversions",
        "acgt_content",
        "insert_size_his",
        "mapped_reads_nucleotide_content",
        "mapped_reads_gc_content_disribution",
        "mapped_read_clipping_profile",
      ],
      "v16/somatic": [
        "cnv_diagram_no_gender",
        "genomic_fraction_coverage",
        "chromosome_based_copy_ratio_no_treshold",
        "chromosome_mean_coverage",
        "mapping_quality_across_reference",
        "coverage_histogram",
        "indel_length",
        "transitions_and_transversions",
        "acgt_content",
        "insert_size_his",
        "mapped_reads_nucleotide_content",
        "mapped_reads_gc_content_disribution",
        "mapped_read_clipping_profile",
      ],
      v17: [
        "cnv_diagram_no_gender",
        "genomic_fraction_coverage",
        "chromosome_based_copy_ratio_no_treshold",
        "chromosome_mean_coverage",
        "mapping_quality_across_reference",
        "coverage_histogram",
        "indel_length",
        "transitions_and_transversions",
        "acgt_content",
        "insert_size_his",
        "mapped_reads_nucleotide_content",
        "mapped_reads_gc_content_disribution",
        "mapped_read_clipping_profile",
      ],
      "v17/somatic": [
        "cnv_diagram_no_gender",
        "genomic_fraction_coverage",
        "chromosome_based_copy_ratio_no_treshold",
        "chromosome_mean_coverage",
        "mapping_quality_across_reference",
        "coverage_histogram",
        "indel_length",
        "transitions_and_transversions",
        "acgt_content",
        "insert_size_his",
        "mapped_reads_nucleotide_content",
        "mapped_reads_gc_content_disribution",
        "mapped_read_clipping_profile",
      ],
      v18: [
        "cnv_diagram_no_gender",
        "genomic_fraction_coverage",
        "chromosome_based_copy_ratio_no_treshold",
        "chromosome_mean_coverage",
        "mapping_quality_across_reference",
        "coverage_histogram",
        "indel_length",
        "transitions_and_transversions",
        "acgt_content",
        "insert_size_his",
        "mapped_reads_nucleotide_content",
        "mapped_reads_gc_content_disribution",
        "mapped_read_clipping_profile",
      ],
      "v18/somatic": [
        "cnv_diagram_no_gender",
        "genomic_fraction_coverage",
        "chromosome_based_copy_ratio_no_treshold",
        "chromosome_mean_coverage",
        "mapping_quality_across_reference",
        "coverage_histogram",
        "indel_length",
        "transitions_and_transversions",
        "acgt_content",
        "insert_size_his",
        "mapped_reads_nucleotide_content",
        "mapped_reads_gc_content_disribution",
        "mapped_read_clipping_profile",
      ],
    },
    statistics: {
      v4: [
        "globals",
        "coverage_(inside_of_regions)",
        "mapping_quality_(inside_of_regions)",
        "mismatches_and_indels_(inside_of_regions)",
        "het_hom_ratio_res",
        "insert_size_(inside_of_regions)",
        "tstv",
      ],
      v5: [
        "globals",
        "coverage_(inside_of_regions)",
        "mapping_quality_(inside_of_regions)",
        "genebase",
        "insert_size_(inside_of_regions)",
        "mismatches_and_indels_(inside_of_regions)",
        "het_hom_ratio_res",
        "tstv",
        "tumor_burden",
      ],
      v6: [
        "globals",
        "coverage_(inside_of_regions)",
        "mapping_quality_(inside_of_regions)",
        "genebase",
        "insert_size_(inside_of_regions)",
        "mismatches_and_indels_(inside_of_regions)",
        "het_hom_ratio_res",
        "tstv",
        "tumor_burden",
      ],
      v7: [
        "globals",
        "coverage_(inside_of_regions)",
        "mapping_quality_(inside_of_regions)",
        "genebase",
        "insert_size_(inside_of_regions)",
        "mismatches_and_indels_(inside_of_regions)",
        "het_hom_ratio_res",
        "tstv",
        "tumor_burden",
      ],
      v8: [
        "globals",
        "coverage_(inside_of_regions)",
        "mapping_quality_(inside_of_regions)",
        "genebase",
        "insert_size_(inside_of_regions)",
        "mismatches_and_indels_(inside_of_regions)",
        "het_hom_ratio_res",
        "tstv",
        "tumor_burden",
      ],
      v9: [
        "globals",
        "coverage_(inside_of_regions)",
        "mapping_quality_(inside_of_regions)",
        "panelPercentages",
        "insert_size_(inside_of_regions)",
        "genebase",
        "het_hom_ratio_res",
        "dijital_panel",
        "tumor_burden",
        "tstv",
        "mismatches_and_indels_(inside_of_regions)",
      ],
      "v10/somatic": [
        "globals",
        "coverage_(inside_of_regions)",
        "mapping_quality_(inside_of_regions)",
        "panelPercentages",
        "insert_size_(inside_of_regions)",
        "genebase",
        "het_hom_ratio_res",
        "dijital_panel",
        "tumor_burden",
        "tstv",
        "mismatches_and_indels_(inside_of_regions)",
      ],
      v10: [
        "globals",
        "coverage_(inside_of_regions)",
        "mapping_quality_(inside_of_regions)",
        "panelPercentages",
        "insert_size_(inside_of_regions)",
        "genebase",
        "het_hom_ratio_res",
        "dijital_panel",
        "tumor_burden",
        "tstv",
        "mismatches_and_indels_(inside_of_regions)",
      ],
      "v11/somatic": [
        "globals",
        "coverage_(inside_of_regions)",
        "mapping_quality_(inside_of_regions)",
        "panelPercentages",
        "insert_size_(inside_of_regions)",
        "genebase",
        "het_hom_ratio_res",
        "dijital_panel",
        "tumor_burden",
        "tstv",
        "mismatches_and_indels_(inside_of_regions)",
      ],
      v11: [
        "globals",
        "coverage_(inside_of_regions)",
        "mapping_quality_(inside_of_regions)",
        "panelPercentages",
        "insert_size_(inside_of_regions)",
        "genebase",
        "het_hom_ratio_res",
        "dijital_panel",
        "tumor_burden",
        "tstv",
        "mismatches_and_indels_(inside_of_regions)",
      ],
      "v12/somatic": [
        "globals",
        "coverage_(inside_of_regions)",
        "mapping_quality_(inside_of_regions)",
        "panelPercentages",
        "insert_size_(inside_of_regions)",
        "genebase",
        "het_hom_ratio_res",
        "dijital_panel",
        "tumor_burden",
        "tstv",
        "mismatches_and_indels_(inside_of_regions)",
      ],
      v12: [
        "globals",
        "coverage_(inside_of_regions)",
        "mapping_quality_(inside_of_regions)",
        "panelPercentages",
        "insert_size_(inside_of_regions)",
        "genebase",
        "het_hom_ratio_res",
        "dijital_panel",
        "tumor_burden",
        "tstv",
        "mismatches_and_indels_(inside_of_regions)",
      ],
      "v13/somatic": [
        "globals",
        "coverage_(inside_of_regions)",
        "mapping_quality_(inside_of_regions)",
        "panelPercentages",
        "insert_size_(inside_of_regions)",
        "genebase",
        "het_hom_ratio_res",
        "dijital_panel",
        "tumor_burden",
        "tstv",
        "mismatches_and_indels_(inside_of_regions)",
      ],
      v13: [
        "globals",
        "coverage_(inside_of_regions)",
        "mapping_quality_(inside_of_regions)",
        "panelPercentages",
        "insert_size_(inside_of_regions)",
        "genebase",
        "het_hom_ratio_res",
        "dijital_panel",
        "tumor_burden",
        "tstv",
        "mismatches_and_indels_(inside_of_regions)",
      ],
      "v14/somatic": [
        "globals",
        "coverage_(inside_of_regions)",
        "mapping_quality_(inside_of_regions)",
        "panelPercentages",
        "insert_size_(inside_of_regions)",
        "genebase",
        "het_hom_ratio_res",
        "dijital_panel",
        "tumor_burden",
        "tstv",
        "mismatches_and_indels_(inside_of_regions)",
      ],
      v14: [
        "globals",
        "coverage_(inside_of_regions)",
        "mapping_quality_(inside_of_regions)",
        "panelPercentages",
        "insert_size_(inside_of_regions)",
        "genebase",
        "het_hom_ratio_res",
        "dijital_panel",
        "tumor_burden",
        "tstv",
        "mismatches_and_indels_(inside_of_regions)",
      ],
      "v15/somatic": [
        "globals",
        "coverage_(inside_of_regions)",
        "mapping_quality_(inside_of_regions)",
        "panelPercentages",
        "insert_size_(inside_of_regions)",
        "genebase",
        "het_hom_ratio_res",
        "dijital_panel",
        "tumor_burden",
        "tstv",
        "mismatches_and_indels_(inside_of_regions)",
      ],
      v15: [
        "globals",
        "coverage_(inside_of_regions)",
        "mapping_quality_(inside_of_regions)",
        "panelPercentages",
        "insert_size_(inside_of_regions)",
        "genebase",
        "het_hom_ratio_res",
        "dijital_panel",
        "tumor_burden",
        "tstv",
        "mismatches_and_indels_(inside_of_regions)",
      ],
      "v16/somatic": [
        "globals",
        "coverage_(inside_of_regions)",
        "mapping_quality_(inside_of_regions)",
        "panelPercentages",
        "insert_size_(inside_of_regions)",
        "genebase",
        "het_hom_ratio_res",
        "dijital_panel",
        "tumor_burden",
        "tstv",
        "mismatches_and_indels_(inside_of_regions)",
      ],
      v16: [
        "globals",
        "coverage_(inside_of_regions)",
        "mapping_quality_(inside_of_regions)",
        "panelPercentages",
        "insert_size_(inside_of_regions)",
        "genebase",
        "het_hom_ratio_res",
        "dijital_panel",
        "tumor_burden",
        "tstv",
        "mismatches_and_indels_(inside_of_regions)",
      ],
      "v17/somatic": [
        "globals",
        "coverage_(inside_of_regions)",
        "globals_(inside_of_regions)",
        "panelPercentages",
        "mapping_quality_(inside_of_regions)",
        "genebase",
        "mismatches_and_indels_(inside_of_regions)",
        "het_hom_ratio_res",
        "insert_size_(inside_of_regions)",
        "dijital_panel",
        "tumor_burden",
        "kit_homogenicity",
        "tstv",
      ],
      v17: [
        "globals",
        "coverage_(inside_of_regions)",
        "mapping_quality_(inside_of_regions)",
        "panelPercentages",
        "insert_size_(inside_of_regions)",
        "genebase",
        "het_hom_ratio_res",
        "dijital_panel",
        "tumor_burden",
        "tstv",
        "mismatches_and_indels_(inside_of_regions)",
        "kit_homogenicity",
        "gender",
      ],
      "v18/somatic": [
        "globals",
        "coverage_(inside_of_regions)",
        "globals_(inside_of_regions)",
        "panelPercentages",
        "kit_homogenicity",
        "genebase",
        "mapping_quality_(inside_of_regions)",
        "het_hom_ratio_res",
        "mismatches_and_indels_(inside_of_regions)",
        "dijital_panel",
        "insert_size_(inside_of_regions)",
        "tumor_burden",
        "fakeTable", // it is a need for fit the tables
        "tstv",
      ],
      v18: [
        "globals",
        "coverage_(inside_of_regions)",
        "globals_(inside_of_regions)",
        "panelPercentages",
        "kit_homogenicity",
        "genebase",
        "mapping_quality_(inside_of_regions)",
        "het_hom_ratio_res",
        "mismatches_and_indels_(inside_of_regions)",
        "dijital_panel",
        "insert_size_(inside_of_regions)",
        "gender",
        "tstv",
      ],
    },
  },
  nanopore: {
    visible: true,
    name: "nanopore",
    label: "Nanopore (Fastq)",
    tabs: {
      statistics: {
        name: "statistics",
        label: "Statistics",
        order: 0,
        component: "",
      },
      variant_table: {
        name: "variant_table",
        label: "Variant table",
        order: 1,
        component: "",
      },
      massive_insight: {
        name: "massive_insight",
        label: "Massive Insight",
        order: 2,
        component: "",
        selectable: false,
      },
    },
    detailsTabs: {
      main: {
        name: "main",
        label: "Main details",
        order: 0,
        component: "",
      },
      pathogenicity: {
        name: "pathogenicity",
        label: "Pathogenicity scores",
        order: 1,
        component: "",
      },
      population_conservation: {
        name: "population_conservation",
        label: "Population frequencies and conservation scores",
        order: 2,
        component: "",
      },
      phenotype_information: {
        name: "phenotype_information",
        label: "Phenotype Databases (ClinGen, Gene2Pheno, Orphanet)",
        order: 3,
        component: "",
      },
      external: {
        name: "external",
        label: "External databases (ClinVar, COSMIC, Phenotype)",
        order: 4,
        component: "",
      },
      biomarker: {
        name: "biomarker",
        label: "Biomarker",
        order: 5,
        component: "",
      },
      comment: {
        name: "comments",
        label: "Comments",
        order: 6,
        component: "",
      },
      igv: {
        name: "igv",
        label: "Genome visualization",
        order: 7,
        component: "",
      },
      uniprot: {
        name: "main",
        label: "Uniprot",
        order: 8,
        component: "",
      },
      related_projects: {
        name: "main",
        label: "Related Projects",
        order: 9,
        component: "",
      },
      customize: {
        name: "main",
        label: "Customized Spesific Values",
        order: 10,
        component: "",
      },
    },
    charts: {
      v4: [
        "cnv_diagram_no_gender",
        "genomic_fraction_coverage",
        "chromosome_based_copy_ratio_no_treshold",
        "chromosome_mean_coverage",
        "mapping_quality_across_reference",
        "coverage_histogram",
        "indel_length",
        "transitions_and_transversions",
        "acgt_content",
        "insert_size_his",
        "mapped_reads_nucleotide_content",
        "mapped_reads_gc_content_disribution",
        "mapped_read_clipping_profile",
      ],
      v5: [
        "cnv_diagram_no_gender",
        "genomic_fraction_coverage",
        "chromosome_based_copy_ratio_no_treshold",
        "chromosome_mean_coverage",
        "mapping_quality_across_reference",
        "coverage_histogram",
        "indel_length",
        "transitions_and_transversions",
        "acgt_content",
        "insert_size_his",
        "mapped_reads_nucleotide_content",
        "mapped_reads_gc_content_disribution",
        "mapped_read_clipping_profile",
      ],
      v6: [
        "cnv_diagram_no_gender",
        "genomic_fraction_coverage",
        "chromosome_based_copy_ratio_no_treshold",
        "chromosome_mean_coverage",
        "mapping_quality_across_reference",
        "coverage_histogram",
        "indel_length",
        "transitions_and_transversions",
        "acgt_content",
        "insert_size_his",
        "mapped_reads_nucleotide_content",
        "mapped_reads_gc_content_disribution",
        "mapped_read_clipping_profile",
      ],
      v7: [
        "cnv_diagram_no_gender",
        "genomic_fraction_coverage",
        "chromosome_based_copy_ratio_no_treshold",
        "chromosome_mean_coverage",
        "mapping_quality_across_reference",
        "coverage_histogram",
        "indel_length",
        "transitions_and_transversions",
        "acgt_content",
        "insert_size_his",
        "mapped_reads_nucleotide_content",
        "mapped_reads_gc_content_disribution",
        "mapped_read_clipping_profile",
      ],
      v8: [
        "cnv_diagram_no_gender",
        "genomic_fraction_coverage",
        "chromosome_based_copy_ratio_no_treshold",
        "chromosome_mean_coverage",
        "mapping_quality_across_reference",
        "coverage_histogram",
        "indel_length",
        "transitions_and_transversions",
        "acgt_content",
        "insert_size_his",
        "mapped_reads_nucleotide_content",
        "mapped_reads_gc_content_disribution",
        "mapped_read_clipping_profile",
      ],
      v9: [
        "cnv_diagram_no_gender",
        "genomic_fraction_coverage",
        "chromosome_based_copy_ratio_no_treshold",
        "chromosome_mean_coverage",
        "mapping_quality_across_reference",
        "coverage_histogram",
        "indel_length",
        "transitions_and_transversions",
        "acgt_content",
        "insert_size_his",
        "mapped_reads_nucleotide_content",
        "mapped_reads_gc_content_disribution",
        "mapped_read_clipping_profile",
      ],
      "v10/somatic": [
        "cnv_diagram_no_gender",
        "genomic_fraction_coverage",
        "chromosome_based_copy_ratio_no_treshold",
        "chromosome_mean_coverage",
        "mapping_quality_across_reference",
        "coverage_histogram",
        "indel_length",
        "transitions_and_transversions",
        "acgt_content",
        "insert_size_his",
        "mapped_reads_nucleotide_content",
        "mapped_reads_gc_content_disribution",
        "mapped_read_clipping_profile",
      ],
      v10: [
        "cnv_diagram_no_gender",
        "genomic_fraction_coverage",
        "chromosome_based_copy_ratio_no_treshold",
        "chromosome_mean_coverage",
        "mapping_quality_across_reference",
        "coverage_histogram",
        "indel_length",
        "transitions_and_transversions",
        "acgt_content",
        "insert_size_his",
        "mapped_reads_nucleotide_content",
        "mapped_reads_gc_content_disribution",
        "mapped_read_clipping_profile",
      ],
      v11: [
        "cnv_diagram_no_gender",
        "genomic_fraction_coverage",
        "chromosome_based_copy_ratio_no_treshold",
        "chromosome_mean_coverage",
        "mapping_quality_across_reference",
        "coverage_histogram",
        "indel_length",
        "transitions_and_transversions",
        "acgt_content",
        "insert_size_his",
        "mapped_reads_nucleotide_content",
        "mapped_reads_gc_content_disribution",
        "mapped_read_clipping_profile",
      ],
      "v11/somatic": [
        "cnv_diagram_no_gender",
        "genomic_fraction_coverage",
        "chromosome_based_copy_ratio_no_treshold",
        "chromosome_mean_coverage",
        "mapping_quality_across_reference",
        "coverage_histogram",
        "indel_length",
        "transitions_and_transversions",
        "acgt_content",
        "insert_size_his",
        "mapped_reads_nucleotide_content",
        "mapped_reads_gc_content_disribution",
        "mapped_read_clipping_profile",
      ],
      v12: [
        "cnv_diagram_no_gender",
        "genomic_fraction_coverage",
        "chromosome_based_copy_ratio_no_treshold",
        "chromosome_mean_coverage",
        "mapping_quality_across_reference",
        "coverage_histogram",
        "indel_length",
        "transitions_and_transversions",
        "acgt_content",
        "insert_size_his",
        "mapped_reads_nucleotide_content",
        "mapped_reads_gc_content_disribution",
        "mapped_read_clipping_profile",
      ],
      "v12/somatic": [
        "cnv_diagram_no_gender",
        "genomic_fraction_coverage",
        "chromosome_based_copy_ratio_no_treshold",
        "chromosome_mean_coverage",
        "mapping_quality_across_reference",
        "coverage_histogram",
        "indel_length",
        "transitions_and_transversions",
        "acgt_content",
        "insert_size_his",
        "mapped_reads_nucleotide_content",
        "mapped_reads_gc_content_disribution",
        "mapped_read_clipping_profile",
      ],
      v13: [
        "cnv_diagram_no_gender",
        "genomic_fraction_coverage",
        "chromosome_based_copy_ratio_no_treshold",
        "chromosome_mean_coverage",
        "mapping_quality_across_reference",
        "coverage_histogram",
        "indel_length",
        "transitions_and_transversions",
        "acgt_content",
        "insert_size_his",
        "mapped_reads_nucleotide_content",
        "mapped_reads_gc_content_disribution",
        "mapped_read_clipping_profile",
      ],
      "v13/somatic": [
        "cnv_diagram_no_gender",
        "genomic_fraction_coverage",
        "chromosome_based_copy_ratio_no_treshold",
        "chromosome_mean_coverage",
        "mapping_quality_across_reference",
        "coverage_histogram",
        "indel_length",
        "transitions_and_transversions",
        "acgt_content",
        "insert_size_his",
        "mapped_reads_nucleotide_content",
        "mapped_reads_gc_content_disribution",
        "mapped_read_clipping_profile",
      ],
      v14: [
        "cnv_diagram_no_gender",
        "genomic_fraction_coverage",
        "chromosome_based_copy_ratio_no_treshold",
        "chromosome_mean_coverage",
        "mapping_quality_across_reference",
        "coverage_histogram",
        "indel_length",
        "transitions_and_transversions",
        "acgt_content",
        "insert_size_his",
        "mapped_reads_nucleotide_content",
        "mapped_reads_gc_content_disribution",
        "mapped_read_clipping_profile",
      ],
      "v14/somatic": [
        "cnv_diagram_no_gender",
        "genomic_fraction_coverage",
        "chromosome_based_copy_ratio_no_treshold",
        "chromosome_mean_coverage",
        "mapping_quality_across_reference",
        "coverage_histogram",
        "indel_length",
        "transitions_and_transversions",
        "acgt_content",
        "insert_size_his",
        "mapped_reads_nucleotide_content",
        "mapped_reads_gc_content_disribution",
        "mapped_read_clipping_profile",
      ],
      v15: [
        "cnv_diagram_no_gender",
        "genomic_fraction_coverage",
        "chromosome_based_copy_ratio_no_treshold",
        "chromosome_mean_coverage",
        "mapping_quality_across_reference",
        "coverage_histogram",
        "indel_length",
        "transitions_and_transversions",
        "acgt_content",
        "insert_size_his",
        "mapped_reads_nucleotide_content",
        "mapped_reads_gc_content_disribution",
        "mapped_read_clipping_profile",
      ],
      "v15/somatic": [
        "cnv_diagram_no_gender",
        "genomic_fraction_coverage",
        "chromosome_based_copy_ratio_no_treshold",
        "chromosome_mean_coverage",
        "mapping_quality_across_reference",
        "coverage_histogram",
        "indel_length",
        "transitions_and_transversions",
        "acgt_content",
        "insert_size_his",
        "mapped_reads_nucleotide_content",
        "mapped_reads_gc_content_disribution",
        "mapped_read_clipping_profile",
      ],
      v16: [
        "cnv_diagram_no_gender",
        "genomic_fraction_coverage",
        "chromosome_based_copy_ratio_no_treshold",
        "chromosome_mean_coverage",
        "mapping_quality_across_reference",
        "coverage_histogram",
        "indel_length",
        "transitions_and_transversions",
        "acgt_content",
        "insert_size_his",
        "mapped_reads_nucleotide_content",
        "mapped_reads_gc_content_disribution",
        "mapped_read_clipping_profile",
      ],
      "v16/somatic": [
        "cnv_diagram_no_gender",
        "genomic_fraction_coverage",
        "chromosome_based_copy_ratio_no_treshold",
        "chromosome_mean_coverage",
        "mapping_quality_across_reference",
        "coverage_histogram",
        "indel_length",
        "transitions_and_transversions",
        "acgt_content",
        "insert_size_his",
        "mapped_reads_nucleotide_content",
        "mapped_reads_gc_content_disribution",
        "mapped_read_clipping_profile",
      ],
      v17: [
        "cnv_diagram_no_gender",
        "genomic_fraction_coverage",
        "chromosome_based_copy_ratio_no_treshold",
        "chromosome_mean_coverage",
        "mapping_quality_across_reference",
        "coverage_histogram",
        "indel_length",
        "transitions_and_transversions",
        "acgt_content",
        "insert_size_his",
        "mapped_reads_nucleotide_content",
        "mapped_reads_gc_content_disribution",
        "mapped_read_clipping_profile",
      ],
      "v17/somatic": [
        "cnv_diagram_no_gender",
        "genomic_fraction_coverage",
        "chromosome_based_copy_ratio_no_treshold",
        "chromosome_mean_coverage",
        "mapping_quality_across_reference",
        "coverage_histogram",
        "indel_length",
        "transitions_and_transversions",
        "acgt_content",
        "insert_size_his",
        "mapped_reads_nucleotide_content",
        "mapped_reads_gc_content_disribution",
        "mapped_read_clipping_profile",
      ],
      v18: [
        "cnv_diagram_no_gender",
        "genomic_fraction_coverage",
        "chromosome_based_copy_ratio_no_treshold",
        "chromosome_mean_coverage",
        "mapping_quality_across_reference",
        "coverage_histogram",
        "indel_length",
        "transitions_and_transversions",
        "acgt_content",
        "insert_size_his",
        "mapped_reads_nucleotide_content",
        "mapped_reads_gc_content_disribution",
        "mapped_read_clipping_profile",
      ],
      "v18/somatic": [
        "cnv_diagram_no_gender",
        "genomic_fraction_coverage",
        "chromosome_based_copy_ratio_no_treshold",
        "chromosome_mean_coverage",
        "mapping_quality_across_reference",
        "coverage_histogram",
        "indel_length",
        "transitions_and_transversions",
        "acgt_content",
        "insert_size_his",
        "mapped_reads_nucleotide_content",
        "mapped_reads_gc_content_disribution",
        "mapped_read_clipping_profile",
      ],
    },
    statistics: {
      v4: [
        "globals",
        "coverage_(inside_of_regions)",
        "mapping_quality_(inside_of_regions)",
        "mismatches_and_indels_(inside_of_regions)",
        "het_hom_ratio_res",
        "insert_size_(inside_of_regions)",
        "tstv",
      ],
      v5: [
        "globals",
        "coverage_(inside_of_regions)",
        "mapping_quality_(inside_of_regions)",
        "genebase",
        "insert_size_(inside_of_regions)",
        "mismatches_and_indels_(inside_of_regions)",
        "het_hom_ratio_res",
        "tstv",
        "tumor_burden",
      ],
      v6: [
        "globals",
        "coverage_(inside_of_regions)",
        "mapping_quality_(inside_of_regions)",
        "genebase",
        "insert_size_(inside_of_regions)",
        "mismatches_and_indels_(inside_of_regions)",
        "het_hom_ratio_res",
        "tstv",
        "tumor_burden",
      ],
      v7: [
        "globals",
        "coverage_(inside_of_regions)",
        "mapping_quality_(inside_of_regions)",
        "genebase",
        "insert_size_(inside_of_regions)",
        "mismatches_and_indels_(inside_of_regions)",
        "het_hom_ratio_res",
        "tstv",
        "tumor_burden",
      ],
      v8: [
        "globals",
        "coverage_(inside_of_regions)",
        "mapping_quality_(inside_of_regions)",
        "genebase",
        "insert_size_(inside_of_regions)",
        "mismatches_and_indels_(inside_of_regions)",
        "het_hom_ratio_res",
        "tstv",
        "tumor_burden",
      ],
      v9: [
        "globals",
        "coverage_(inside_of_regions)",
        "mapping_quality_(inside_of_regions)",
        "panelPercentages",
        "insert_size_(inside_of_regions)",
        "genebase",
        "het_hom_ratio_res",
        "dijital_panel",
        "tumor_burden",
        "tstv",
        "mismatches_and_indels_(inside_of_regions)",
      ],
      "v10/somatic": [
        "globals",
        "coverage_(inside_of_regions)",
        "mapping_quality_(inside_of_regions)",
        "panelPercentages",
        "insert_size_(inside_of_regions)",
        "genebase",
        "het_hom_ratio_res",
        "dijital_panel",
        "tumor_burden",
        "tstv",
        "mismatches_and_indels_(inside_of_regions)",
      ],
      v10: [
        "globals",
        "coverage_(inside_of_regions)",
        "mapping_quality_(inside_of_regions)",
        "panelPercentages",
        "insert_size_(inside_of_regions)",
        "genebase",
        "het_hom_ratio_res",
        "dijital_panel",
        "tumor_burden",
        "tstv",
        "mismatches_and_indels_(inside_of_regions)",
      ],
      "v11/somatic": [
        "globals",
        "coverage_(inside_of_regions)",
        "mapping_quality_(inside_of_regions)",
        "panelPercentages",
        "insert_size_(inside_of_regions)",
        "genebase",
        "het_hom_ratio_res",
        "dijital_panel",
        "tumor_burden",
        "tstv",
        "mismatches_and_indels_(inside_of_regions)",
      ],
      v11: [
        "globals",
        "coverage_(inside_of_regions)",
        "mapping_quality_(inside_of_regions)",
        "panelPercentages",
        "insert_size_(inside_of_regions)",
        "genebase",
        "het_hom_ratio_res",
        "dijital_panel",
        "tumor_burden",
        "tstv",
        "mismatches_and_indels_(inside_of_regions)",
      ],
      "v12/somatic": [
        "globals",
        "coverage_(inside_of_regions)",
        "mapping_quality_(inside_of_regions)",
        "panelPercentages",
        "insert_size_(inside_of_regions)",
        "genebase",
        "het_hom_ratio_res",
        "dijital_panel",
        "tumor_burden",
        "tstv",
        "mismatches_and_indels_(inside_of_regions)",
      ],
      v12: [
        "globals",
        "coverage_(inside_of_regions)",
        "mapping_quality_(inside_of_regions)",
        "panelPercentages",
        "insert_size_(inside_of_regions)",
        "genebase",
        "het_hom_ratio_res",
        "dijital_panel",
        "tumor_burden",
        "tstv",
        "mismatches_and_indels_(inside_of_regions)",
      ],
      "v13/somatic": [
        "globals",
        "coverage_(inside_of_regions)",
        "mapping_quality_(inside_of_regions)",
        "panelPercentages",
        "insert_size_(inside_of_regions)",
        "genebase",
        "het_hom_ratio_res",
        "dijital_panel",
        "tumor_burden",
        "tstv",
        "mismatches_and_indels_(inside_of_regions)",
      ],
      v13: [
        "globals",
        "coverage_(inside_of_regions)",
        "mapping_quality_(inside_of_regions)",
        "panelPercentages",
        "insert_size_(inside_of_regions)",
        "genebase",
        "het_hom_ratio_res",
        "dijital_panel",
        "tumor_burden",
        "tstv",
        "mismatches_and_indels_(inside_of_regions)",
      ],
      "v14/somatic": [
        "globals",
        "coverage_(inside_of_regions)",
        "mapping_quality_(inside_of_regions)",
        "panelPercentages",
        "insert_size_(inside_of_regions)",
        "genebase",
        "het_hom_ratio_res",
        "dijital_panel",
        "tumor_burden",
        "tstv",
        "mismatches_and_indels_(inside_of_regions)",
      ],
      v14: [
        "globals",
        "coverage_(inside_of_regions)",
        "mapping_quality_(inside_of_regions)",
        "panelPercentages",
        "insert_size_(inside_of_regions)",
        "genebase",
        "het_hom_ratio_res",
        "dijital_panel",
        "tumor_burden",
        "tstv",
        "mismatches_and_indels_(inside_of_regions)",
      ],
      "v15/somatic": [
        "globals",
        "coverage_(inside_of_regions)",
        "mapping_quality_(inside_of_regions)",
        "panelPercentages",
        "insert_size_(inside_of_regions)",
        "genebase",
        "het_hom_ratio_res",
        "dijital_panel",
        "tumor_burden",
        "tstv",
        "mismatches_and_indels_(inside_of_regions)",
      ],
      v15: [
        "globals",
        "coverage_(inside_of_regions)",
        "mapping_quality_(inside_of_regions)",
        "panelPercentages",
        "insert_size_(inside_of_regions)",
        "genebase",
        "het_hom_ratio_res",
        "dijital_panel",
        "tumor_burden",
        "tstv",
        "mismatches_and_indels_(inside_of_regions)",
      ],
      "v16/somatic": [
        "globals",
        "coverage_(inside_of_regions)",
        "mapping_quality_(inside_of_regions)",
        "panelPercentages",
        "insert_size_(inside_of_regions)",
        "genebase",
        "het_hom_ratio_res",
        "dijital_panel",
        "tumor_burden",
        "tstv",
        "mismatches_and_indels_(inside_of_regions)",
      ],
      v16: [
        "globals",
        "coverage_(inside_of_regions)",
        "mapping_quality_(inside_of_regions)",
        "panelPercentages",
        "insert_size_(inside_of_regions)",
        "genebase",
        "het_hom_ratio_res",
        "dijital_panel",
        "tumor_burden",
        "tstv",
        "mismatches_and_indels_(inside_of_regions)",
      ],
      "v17/somatic": [
        "globals",
        "coverage_(inside_of_regions)",
        "mapping_quality_(inside_of_regions)",
        "panelPercentages",
        "insert_size_(inside_of_regions)",
        "genebase",
        "het_hom_ratio_res",
        "dijital_panel",
        "tumor_burden",
        "tstv",
        "mismatches_and_indels_(inside_of_regions)",
      ],
      v17: [
        "globals",
        "coverage_(inside_of_regions)",
        "mapping_quality_(inside_of_regions)",
        "panelPercentages",
        "insert_size_(inside_of_regions)",
        "genebase",
        "het_hom_ratio_res",
        "dijital_panel",
        "tumor_burden",
        "tstv",
        "mismatches_and_indels_(inside_of_regions)",
      ],
      "v18/somatic": [
        "globals",
        "coverage_(inside_of_regions)",
        "mapping_quality_(inside_of_regions)",
        "panelPercentages",
        "insert_size_(inside_of_regions)",
        "genebase",
        "het_hom_ratio_res",
        "dijital_panel",
        "tumor_burden",
        "tstv",
        "mismatches_and_indels_(inside_of_regions)",
      ],
      v18: [
        "globals",
        "coverage_(inside_of_regions)",
        "mapping_quality_(inside_of_regions)",
        "panelPercentages",
        "insert_size_(inside_of_regions)",
        "genebase",
        "het_hom_ratio_res",
        "dijital_panel",
        "tumor_burden",
        "tstv",
        "mismatches_and_indels_(inside_of_regions)",
      ],
    },
  },
  exome_vcf: {
    visible: true,
    name: "exome_vcf",
    label: "Exome (VCF)",
    tabs: {
      statistics: {
        name: "statistics",
        label: "Statistics",
        order: 0,
        component: "",
      },
      variant_table: {
        name: "variant_table",
        label: "Variant table",
        order: 1,
        component: "",
      },
      massive_insight: {
        name: "massive_insight",
        label: "Massive Insight",
        order: 2,
        component: "",
        selectable: false,
      },
    },
    detailsTabs: {
      main: {
        name: "main",
        label: "Main details",
        order: 0,
        component: "",
      },
      pathogenicity: {
        name: "pathogenicity",
        label: "Pathogenicity scores",
        order: 1,
        component: "",
      },
      population_conservation: {
        name: "population_conservation",
        label: "Population frequencies and conservation scores",
        order: 2,
        component: "",
      },
      external: {
        name: "external",
        label: "External databases (ClinVar, COSMIC, Phenotype)",
        order: 3,
        component: "",
      },
      phenotype_information: {
        name: "phenotype_information",
        label: "Phenotype Databases (ClinGen, Gene2Pheno, Orphanet)",
        order: 4,
        component: "",
      },
      biomarker: {
        name: "biomarker",
        label: "Biomarker",
        order: 5,
        component: "",
      },
      comment: {
        name: "comments",
        label: "Comments",
        order: 6,
        component: "",
      },
      uniprot: {
        name: "main",
        label: "Uniprot",
        order: 7,
        component: "",
      },
      related_projects: {
        name: "main",
        label: "Related Projects",
        order: 8,
        component: "",
      },
      customize: {
        name: "main",
        label: "Customized Spesific Values",
        order: 9,
        component: "",
      },
    },
    charts: {
      v5: ["indel_length", "transitions_and_transversions"],
      v6: ["indel_length", "transitions_and_transversions"],
      v7: ["indel_length", "transitions_and_transversions"],
      v8: ["indel_length", "transitions_and_transversions"],
      v9: ["indel_length", "transitions_and_transversions"],
      "v10/somatic": ["indel_length", "transitions_and_transversions"],
      v10: ["indel_length", "transitions_and_transversions"],
      v11: ["indel_length", "transitions_and_transversions"],
      "v11/somatic": ["indel_length", "transitions_and_transversions"],
      v12: ["indel_length", "transitions_and_transversions"],
      "v12/somatic": ["indel_length", "transitions_and_transversions"],
      v13: ["indel_length", "transitions_and_transversions"],
      "v13/somatic": ["indel_length", "transitions_and_transversions"],
      v14: ["indel_length", "transitions_and_transversions"],
      "v14/somatic": ["indel_length", "transitions_and_transversions"],
      v15: ["indel_length", "transitions_and_transversions"],
      "v15/somatic": ["indel_length", "transitions_and_transversions"],
      v16: ["indel_length", "transitions_and_transversions"],
      "v16/somatic": ["indel_length", "transitions_and_transversions"],
      v17: ["indel_length", "transitions_and_transversions"],
      "v17/somatic": ["indel_length", "transitions_and_transversions"],
      v18: ["indel_length", "transitions_and_transversions"],
      "v18/somatic": ["indel_length", "transitions_and_transversions"],
    },
    statistics: {
      v5: ["het_hom_ratio_res", "tstv"],
      v6: ["het_hom_ratio_res", "tstv"],
      v7: ["het_hom_ratio_res", "tstv"],
      v9: ["het_hom_ratio_res", "tstv"],
      "v10/somatic": ["het_hom_ratio_res", "tstv"],
      v10: ["het_hom_ratio_res", "tstv"],
      "v11/somatic": ["het_hom_ratio_res", "tstv"],
      v11: ["het_hom_ratio_res", "tstv"],
      "v12/somatic": ["het_hom_ratio_res", "tstv"],
      v12: ["het_hom_ratio_res", "tstv"],
      "v13/somatic": ["het_hom_ratio_res", "tstv"],
      v13: ["het_hom_ratio_res", "tstv"],
      "v14/somatic": ["het_hom_ratio_res", "tstv"],
      v14: ["het_hom_ratio_res", "tstv"],
      "v15/somatic": ["het_hom_ratio_res", "tstv"],
      v15: ["het_hom_ratio_res", "tstv"],
      "v16/somatic": ["het_hom_ratio_res", "tstv"],
      v16: ["het_hom_ratio_res", "tstv"],
      "v17/somatic": ["het_hom_ratio_res", "tstv"],
      v17: ["het_hom_ratio_res", "tstv"],
      "v18/somatic": ["het_hom_ratio_res", "tstv"],
      v18: ["het_hom_ratio_res", "tstv"],
    },
  },
  exome_bam: {
    visible: true,
    name: "exome_bam",
    label: "Exome (BAM)",
    tabs: {
      statistics: {
        name: "statistics",
        label: "Statistics",
        order: 0,
        component: "",
      },
      variant_table: {
        name: "variant_table",
        label: "Variant table",
        order: 1,
        component: "",
      },
      cnv: {
        name: "cnv",
        label: "CNV",
        order: 2,
        component: "",
      },
      massive_insight: {
        name: "massive_insight",
        label: "Massive Insight",
        order: 3,
        component: "",
        selectable: false,
      },
    },
    detailsTabs: {
      main: {
        name: "main",
        label: "Main details",
        order: 0,
        component: "",
      },
      pathogenicity: {
        name: "pathogenicity",
        label: "Pathogenicity scores",
        order: 1,
        component: "",
      },
      population_conservation: {
        name: "population_conservation",
        label: "Population frequencies and conservation scores",
        order: 2,
        component: "",
      },
      external: {
        name: "external",
        label: "External databases (ClinVar, COSMIC, Phenotype)",
        order: 3,
        component: "",
      },
      phenotype_information: {
        name: "phenotype_information",
        label: "Phenotype Databases (ClinGen, Gene2Pheno, Orphanet)",
        order: 4,
        component: "",
      },
      biomarker: {
        name: "biomarker",
        label: "Biomarker",
        order: 5,
        component: "",
      },
      comment: {
        name: "comments",
        label: "Comments",
        order: 6,
        component: "",
      },
      igv: {
        name: "igv",
        label: "Genome visualization",
        order: 7,
        component: "",
      },
      uniprot: {
        name: "main",
        label: "Uniprot",
        order: 8,
        component: "",
      },
      related_projects: {
        name: "main",
        label: "Related Projects",
        order: 9,
        component: "",
      },
      customize: {
        name: "main",
        label: "Customized Spesific Values",
        order: 10,
        component: "",
      },
    },
    charts: {
      v5: [
        "cnv_diagram_no_gender",
        "genomic_fraction_coverage",
        "chromosome_based_copy_ratio_no_treshold",
        "chromosome_mean_coverage",
        "mapping_quality_across_reference",
        "coverage_histogram",
        "indel_length",
        "transitions_and_transversions",
        "acgt_content",
        "insert_size_his",
        "mapped_reads_nucleotide_content",
        "mapped_reads_gc_content_disribution",
        "mapped_read_clipping_profile",
      ],
      v6: [
        "cnv_diagram_no_gender",
        "genomic_fraction_coverage",
        "chromosome_based_copy_ratio_no_treshold",
        "chromosome_mean_coverage",
        "mapping_quality_across_reference",
        "coverage_histogram",
        "indel_length",
        "transitions_and_transversions",
        "acgt_content",
        "insert_size_his",
        "mapped_reads_nucleotide_content",
        "mapped_reads_gc_content_disribution",
        "mapped_read_clipping_profile",
      ],
      v7: [
        "cnv_diagram_no_gender",
        "genomic_fraction_coverage",
        "chromosome_based_copy_ratio_no_treshold",
        "chromosome_mean_coverage",
        "mapping_quality_across_reference",
        "coverage_histogram",
        "indel_length",
        "transitions_and_transversions",
        "acgt_content",
        "insert_size_his",
        "mapped_reads_nucleotide_content",
        "mapped_reads_gc_content_disribution",
        "mapped_read_clipping_profile",
      ],
      v8: [
        "cnv_diagram_no_gender",
        "genomic_fraction_coverage",
        "chromosome_based_copy_ratio_no_treshold",
        "chromosome_mean_coverage",
        "mapping_quality_across_reference",
        "coverage_histogram",
        "indel_length",
        "transitions_and_transversions",
        "acgt_content",
        "insert_size_his",
        "mapped_reads_nucleotide_content",
        "mapped_reads_gc_content_disribution",
        "mapped_read_clipping_profile",
      ],
      v9: [
        "cnv_diagram_no_gender",
        "genomic_fraction_coverage",
        "chromosome_based_copy_ratio_no_treshold",
        "chromosome_mean_coverage",
        "mapping_quality_across_reference",
        "coverage_histogram",
        "indel_length",
        "transitions_and_transversions",
        "acgt_content",
        "insert_size_his",
        "mapped_reads_nucleotide_content",
        "mapped_reads_gc_content_disribution",
        "mapped_read_clipping_profile",
      ],
      "v10/somatic": [
        "cnv_diagram_no_gender",
        "genomic_fraction_coverage",
        "chromosome_based_copy_ratio_no_treshold",
        "chromosome_mean_coverage",
        "mapping_quality_across_reference",
        "coverage_histogram",
        "indel_length",
        "transitions_and_transversions",
        "acgt_content",
        "insert_size_his",
        "mapped_reads_nucleotide_content",
        "mapped_reads_gc_content_disribution",
        "mapped_read_clipping_profile",
      ],
      v10: [
        "cnv_diagram_no_gender",
        "genomic_fraction_coverage",
        "chromosome_based_copy_ratio_no_treshold",
        "chromosome_mean_coverage",
        "mapping_quality_across_reference",
        "coverage_histogram",
        "indel_length",
        "transitions_and_transversions",
        "acgt_content",
        "insert_size_his",
        "mapped_reads_nucleotide_content",
        "mapped_reads_gc_content_disribution",
        "mapped_read_clipping_profile",
      ],
      v11: [
        "cnv_diagram_no_gender",
        "genomic_fraction_coverage",
        "chromosome_based_copy_ratio_no_treshold",
        "chromosome_mean_coverage",
        "mapping_quality_across_reference",
        "coverage_histogram",
        "indel_length",
        "transitions_and_transversions",
        "acgt_content",
        "insert_size_his",
        "mapped_reads_nucleotide_content",
        "mapped_reads_gc_content_disribution",
        "mapped_read_clipping_profile",
      ],
      "v11/somatic": [
        "cnv_diagram_no_gender",
        "genomic_fraction_coverage",
        "chromosome_based_copy_ratio_no_treshold",
        "chromosome_mean_coverage",
        "mapping_quality_across_reference",
        "coverage_histogram",
        "indel_length",
        "transitions_and_transversions",
        "acgt_content",
        "insert_size_his",
        "mapped_reads_nucleotide_content",
        "mapped_reads_gc_content_disribution",
        "mapped_read_clipping_profile",
      ],
      v12: [
        "cnv_diagram_no_gender",
        "genomic_fraction_coverage",
        "chromosome_based_copy_ratio_no_treshold",
        "chromosome_mean_coverage",
        "mapping_quality_across_reference",
        "coverage_histogram",
        "indel_length",
        "transitions_and_transversions",
        "acgt_content",
        "insert_size_his",
        "mapped_reads_nucleotide_content",
        "mapped_reads_gc_content_disribution",
        "mapped_read_clipping_profile",
      ],
      "v12/somatic": [
        "cnv_diagram_no_gender",
        "genomic_fraction_coverage",
        "chromosome_based_copy_ratio_no_treshold",
        "chromosome_mean_coverage",
        "mapping_quality_across_reference",
        "coverage_histogram",
        "indel_length",
        "transitions_and_transversions",
        "acgt_content",
        "insert_size_his",
        "mapped_reads_nucleotide_content",
        "mapped_reads_gc_content_disribution",
        "mapped_read_clipping_profile",
      ],
      v13: [
        "cnv_diagram_no_gender",
        "genomic_fraction_coverage",
        "chromosome_based_copy_ratio_no_treshold",
        "chromosome_mean_coverage",
        "mapping_quality_across_reference",
        "coverage_histogram",
        "indel_length",
        "transitions_and_transversions",
        "acgt_content",
        "insert_size_his",
        "mapped_reads_nucleotide_content",
        "mapped_reads_gc_content_disribution",
        "mapped_read_clipping_profile",
      ],
      "v13/somatic": [
        "cnv_diagram_no_gender",
        "genomic_fraction_coverage",
        "chromosome_based_copy_ratio_no_treshold",
        "chromosome_mean_coverage",
        "mapping_quality_across_reference",
        "coverage_histogram",
        "indel_length",
        "transitions_and_transversions",
        "acgt_content",
        "insert_size_his",
        "mapped_reads_nucleotide_content",
        "mapped_reads_gc_content_disribution",
        "mapped_read_clipping_profile",
      ],
      v14: [
        "cnv_diagram_no_gender",
        "genomic_fraction_coverage",
        "chromosome_based_copy_ratio_no_treshold",
        "chromosome_mean_coverage",
        "mapping_quality_across_reference",
        "coverage_histogram",
        "indel_length",
        "transitions_and_transversions",
        "acgt_content",
        "insert_size_his",
        "mapped_reads_nucleotide_content",
        "mapped_reads_gc_content_disribution",
        "mapped_read_clipping_profile",
      ],
      "v14/somatic": [
        "cnv_diagram_no_gender",
        "genomic_fraction_coverage",
        "chromosome_based_copy_ratio_no_treshold",
        "chromosome_mean_coverage",
        "mapping_quality_across_reference",
        "coverage_histogram",
        "indel_length",
        "transitions_and_transversions",
        "acgt_content",
        "insert_size_his",
        "mapped_reads_nucleotide_content",
        "mapped_reads_gc_content_disribution",
        "mapped_read_clipping_profile",
      ],
      v15: [
        "cnv_diagram_no_gender",
        "genomic_fraction_coverage",
        "chromosome_based_copy_ratio_no_treshold",
        "chromosome_mean_coverage",
        "mapping_quality_across_reference",
        "coverage_histogram",
        "indel_length",
        "transitions_and_transversions",
        "acgt_content",
        "insert_size_his",
        "mapped_reads_nucleotide_content",
        "mapped_reads_gc_content_disribution",
        "mapped_read_clipping_profile",
      ],
      "v15/somatic": [
        "cnv_diagram_no_gender",
        "genomic_fraction_coverage",
        "chromosome_based_copy_ratio_no_treshold",
        "chromosome_mean_coverage",
        "mapping_quality_across_reference",
        "coverage_histogram",
        "indel_length",
        "transitions_and_transversions",
        "acgt_content",
        "insert_size_his",
        "mapped_reads_nucleotide_content",
        "mapped_reads_gc_content_disribution",
        "mapped_read_clipping_profile",
      ],
      v16: [
        "cnv_diagram_no_gender",
        "genomic_fraction_coverage",
        "chromosome_based_copy_ratio_no_treshold",
        "chromosome_mean_coverage",
        "mapping_quality_across_reference",
        "coverage_histogram",
        "indel_length",
        "transitions_and_transversions",
        "acgt_content",
        "insert_size_his",
        "mapped_reads_nucleotide_content",
        "mapped_reads_gc_content_disribution",
        "mapped_read_clipping_profile",
      ],
      "v16/somatic": [
        "cnv_diagram_no_gender",
        "genomic_fraction_coverage",
        "chromosome_based_copy_ratio_no_treshold",
        "chromosome_mean_coverage",
        "mapping_quality_across_reference",
        "coverage_histogram",
        "indel_length",
        "transitions_and_transversions",
        "acgt_content",
        "insert_size_his",
        "mapped_reads_nucleotide_content",
        "mapped_reads_gc_content_disribution",
        "mapped_read_clipping_profile",
      ],
      v17: [
        "cnv_diagram_no_gender",
        "genomic_fraction_coverage",
        "chromosome_based_copy_ratio_no_treshold",
        "chromosome_mean_coverage",
        "mapping_quality_across_reference",
        "coverage_histogram",
        "indel_length",
        "transitions_and_transversions",
        "acgt_content",
        "insert_size_his",
        "mapped_reads_nucleotide_content",
        "mapped_reads_gc_content_disribution",
        "mapped_read_clipping_profile",
      ],
      "v17/somatic": [
        "cnv_diagram_no_gender",
        "genomic_fraction_coverage",
        "chromosome_based_copy_ratio_no_treshold",
        "chromosome_mean_coverage",
        "mapping_quality_across_reference",
        "coverage_histogram",
        "indel_length",
        "transitions_and_transversions",
        "acgt_content",
        "insert_size_his",
        "mapped_reads_nucleotide_content",
        "mapped_reads_gc_content_disribution",
        "mapped_read_clipping_profile",
      ],
      v18: [
        "cnv_diagram_no_gender",
        "genomic_fraction_coverage",
        "chromosome_based_copy_ratio_no_treshold",
        "chromosome_mean_coverage",
        "mapping_quality_across_reference",
        "coverage_histogram",
        "indel_length",
        "transitions_and_transversions",
        "acgt_content",
        "insert_size_his",
        "mapped_reads_nucleotide_content",
        "mapped_reads_gc_content_disribution",
        "mapped_read_clipping_profile",
      ],
      "v18/somatic": [
        "cnv_diagram_no_gender",
        "genomic_fraction_coverage",
        "chromosome_based_copy_ratio_no_treshold",
        "chromosome_mean_coverage",
        "mapping_quality_across_reference",
        "coverage_histogram",
        "indel_length",
        "transitions_and_transversions",
        "acgt_content",
        "insert_size_his",
        "mapped_reads_nucleotide_content",
        "mapped_reads_gc_content_disribution",
        "mapped_read_clipping_profile",
      ],
    },
    statistics: {
      v5: [
        "globals",
        "coverage_(inside_of_regions)",
        "mapping_quality_(inside_of_regions)",
        "genebase",
        "insert_size_(inside_of_regions)",
        "mismatches_and_indels_(inside_of_regions)",
        "het_hom_ratio_res",
        "tstv",
        "tumor_burden",
      ],
      v6: [
        "globals",
        "coverage_(inside_of_regions)",
        "mapping_quality_(inside_of_regions)",
        "genebase",
        "insert_size_(inside_of_regions)",
        "mismatches_and_indels_(inside_of_regions)",
        "het_hom_ratio_res",
        "tstv",
        "tumor_burden",
      ],
      v7: [
        "globals",
        "coverage_(inside_of_regions)",
        "mapping_quality_(inside_of_regions)",
        "genebase",
        "insert_size_(inside_of_regions)",
        "mismatches_and_indels_(inside_of_regions)",
        "het_hom_ratio_res",
        "tstv",
        "tumor_burden",
      ],
      v8: [
        "globals",
        "coverage_(inside_of_regions)",
        "mapping_quality_(inside_of_regions)",
        "genebase",
        "insert_size_(inside_of_regions)",
        "mismatches_and_indels_(inside_of_regions)",
        "het_hom_ratio_res",
        "tstv",
        "tumor_burden",
      ],
      v9: [
        "globals",
        "coverage_(inside_of_regions)",
        "mapping_quality_(inside_of_regions)",
        "panelPercentages",
        "insert_size_(inside_of_regions)",
        "genebase",
        "het_hom_ratio_res",
        "dijital_panel",
        "tumor_burden",
        "tstv",
        "mismatches_and_indels_(inside_of_regions)",
      ],
      "v10/somatic": [
        "globals",
        "coverage_(inside_of_regions)",
        "mapping_quality_(inside_of_regions)",
        "panelPercentages",
        "insert_size_(inside_of_regions)",
        "genebase",
        "het_hom_ratio_res",
        "dijital_panel",
        "tumor_burden",
        "tstv",
        "mismatches_and_indels_(inside_of_regions)",
      ],
      v10: [
        "globals",
        "coverage_(inside_of_regions)",
        "mapping_quality_(inside_of_regions)",
        "panelPercentages",
        "insert_size_(inside_of_regions)",
        "genebase",
        "het_hom_ratio_res",
        "dijital_panel",
        "tumor_burden",
        "tstv",
        "mismatches_and_indels_(inside_of_regions)",
      ],
      v11: [
        "globals",
        "coverage_(inside_of_regions)",
        "mapping_quality_(inside_of_regions)",
        "panelPercentages",
        "insert_size_(inside_of_regions)",
        "genebase",
        "het_hom_ratio_res",
        "dijital_panel",
        "tumor_burden",
        "tstv",
        "mismatches_and_indels_(inside_of_regions)",
      ],
      v12: [
        "globals",
        "coverage_(inside_of_regions)",
        "mapping_quality_(inside_of_regions)",
        "panelPercentages",
        "insert_size_(inside_of_regions)",
        "genebase",
        "het_hom_ratio_res",
        "dijital_panel",
        "tumor_burden",
        "tstv",
        "mismatches_and_indels_(inside_of_regions)",
      ],
      "v12/somatic": [
        "globals",
        "coverage_(inside_of_regions)",
        "mapping_quality_(inside_of_regions)",
        "panelPercentages",
        "insert_size_(inside_of_regions)",
        "genebase",
        "het_hom_ratio_res",
        "dijital_panel",
        "tumor_burden",
        "tstv",
        "mismatches_and_indels_(inside_of_regions)",
      ],
      v13: [
        "globals",
        "coverage_(inside_of_regions)",
        "mapping_quality_(inside_of_regions)",
        "panelPercentages",
        "insert_size_(inside_of_regions)",
        "genebase",
        "het_hom_ratio_res",
        "dijital_panel",
        "tumor_burden",
        "tstv",
        "mismatches_and_indels_(inside_of_regions)",
      ],
      "v13/somatic": [
        "globals",
        "coverage_(inside_of_regions)",
        "mapping_quality_(inside_of_regions)",
        "panelPercentages",
        "insert_size_(inside_of_regions)",
        "genebase",
        "het_hom_ratio_res",
        "dijital_panel",
        "tumor_burden",
        "tstv",
        "mismatches_and_indels_(inside_of_regions)",
      ],
      v14: [
        "globals",
        "coverage_(inside_of_regions)",
        "mapping_quality_(inside_of_regions)",
        "panelPercentages",
        "insert_size_(inside_of_regions)",
        "genebase",
        "het_hom_ratio_res",
        "dijital_panel",
        "tumor_burden",
        "tstv",
        "mismatches_and_indels_(inside_of_regions)",
      ],
      "v14/somatic": [
        "globals",
        "coverage_(inside_of_regions)",
        "mapping_quality_(inside_of_regions)",
        "panelPercentages",
        "insert_size_(inside_of_regions)",
        "genebase",
        "het_hom_ratio_res",
        "dijital_panel",
        "tumor_burden",
        "tstv",
        "mismatches_and_indels_(inside_of_regions)",
      ],
      v15: [
        "globals",
        "coverage_(inside_of_regions)",
        "mapping_quality_(inside_of_regions)",
        "panelPercentages",
        "insert_size_(inside_of_regions)",
        "genebase",
        "het_hom_ratio_res",
        "dijital_panel",
        "tumor_burden",
        "tstv",
        "mismatches_and_indels_(inside_of_regions)",
      ],
      "v15/somatic": [
        "globals",
        "coverage_(inside_of_regions)",
        "mapping_quality_(inside_of_regions)",
        "panelPercentages",
        "insert_size_(inside_of_regions)",
        "genebase",
        "het_hom_ratio_res",
        "dijital_panel",
        "tumor_burden",
        "tstv",
        "mismatches_and_indels_(inside_of_regions)",
      ],
      v16: [
        "globals",
        "coverage_(inside_of_regions)",
        "mapping_quality_(inside_of_regions)",
        "panelPercentages",
        "insert_size_(inside_of_regions)",
        "genebase",
        "het_hom_ratio_res",
        "dijital_panel",
        "tumor_burden",
        "tstv",
        "mismatches_and_indels_(inside_of_regions)",
      ],
      "v16/somatic": [
        "globals",
        "coverage_(inside_of_regions)",
        "mapping_quality_(inside_of_regions)",
        "panelPercentages",
        "insert_size_(inside_of_regions)",
        "genebase",
        "het_hom_ratio_res",
        "dijital_panel",
        "tumor_burden",
        "tstv",
        "mismatches_and_indels_(inside_of_regions)",
      ],
      v17: [
        "globals",
        "coverage_(inside_of_regions)",
        "mapping_quality_(inside_of_regions)",
        "panelPercentages",
        "insert_size_(inside_of_regions)",
        "genebase",
        "het_hom_ratio_res",
        "dijital_panel",
        "tumor_burden",
        "tstv",
        "mismatches_and_indels_(inside_of_regions)",
        "gender",
        "kit_homogenicity",
      ],
      "v17/somatic": [
        "globals",
        "coverage_(inside_of_regions)",
        "mapping_quality_(inside_of_regions)",
        "panelPercentages",
        "insert_size_(inside_of_regions)",
        "genebase",
        "het_hom_ratio_res",
        "dijital_panel",
        "tumor_burden",
        "tstv",
        "mismatches_and_indels_(inside_of_regions)",
        "kit_homogenicity",
      ],
      v18: [
        "globals",
        "coverage_(inside_of_regions)",
        "mapping_quality_(inside_of_regions)",
        "panelPercentages",
        "insert_size_(inside_of_regions)",
        "genebase",
        "het_hom_ratio_res",
        "dijital_panel",
        "tumor_burden",
        "tstv",
        "mismatches_and_indels_(inside_of_regions)",
        "gender",
        "kit_homogenicity",
      ],
      "v18/somatic": [
        "globals",
        "coverage_(inside_of_regions)",
        "mapping_quality_(inside_of_regions)",
        "panelPercentages",
        "insert_size_(inside_of_regions)",
        "genebase",
        "het_hom_ratio_res",
        "dijital_panel",
        "tumor_burden",
        "tstv",
        "mismatches_and_indels_(inside_of_regions)",
        "kit_homogenicity",
      ],
    },
  },
  trio: {
    visible: true,
    name: "trio",
    label: "Trio",
    tabs: {
      statistics: {
        name: "statistics",
        label: "Statistics",
        order: 0,
        component: "",
      },
      variant_table: {
        name: "variant_table",
        label: "Variant table",
        order: 1,
        component: "",
      },
    },
    detailsTabs: {
      main: {
        name: "main",
        label: "Main details",
        order: 0,
        component: "",
      },
      pathogenicity: {
        name: "pathogenicity",
        label: "Pathogenicity scores",
        order: 1,
        component: "",
      },
      population_conservation: {
        name: "population_conservation",
        label: "Population frequencies and conservation scores",
        order: 2,
        component: "",
      },
      external: {
        name: "external",
        label: "External databases (ClinVar, COSMIC, Phenotype)",
        order: 3,
        component: "",
      },
      phenotype_information: {
        name: "phenotype_information",
        label: "Phenotype Databases (ClinGen, Gene2Pheno, Orphanet)",
        order: 4,
        component: "",
      },
      biomarker: {
        name: "biomarker",
        label: "Biomarker",
        order: 5,
        component: "",
      },
      comment: {
        name: "comments",
        label: "Comments",
        order: 6,
        component: "",
      },
      igv: {
        name: "igv",
        label: "Genome visualization",
        order: 7,
        component: "",
      },
      uniprot: {
        name: "main",
        label: "Uniprot",
        order: 8,
        component: "",
      },
      related_projects: {
        name: "main",
        label: "Related Projects",
        order: 9,
        component: "",
      },
      customize: {
        name: "main",
        label: "Customized Spesific Values",
        order: 10,
        component: "",
      },
    },
    charts: {
      v0: [
        "indel_length",
        "transitions_and_transversions",
        "genomic_fraction_coverage",
        "chromosome_mean_coverage",
        "mapping_quality_across_reference",
        "coverage_histogram",
        "acgt_content",
        "insert_size_his",
        "mapped_reads_nucleotide_content",
        "mapped_reads_gc_content_disribution",
        "mapped_read_clipping_profile",
      ],
      v1: [
        "indel_length",
        "transitions_and_transversions",
        "genomic_fraction_coverage",
        "chromosome_mean_coverage",
        "mapping_quality_across_reference",
        "coverage_histogram",
        "acgt_content",
        "insert_size_his",
        "mapped_reads_nucleotide_content",
        "mapped_reads_gc_content_disribution",
        "mapped_read_clipping_profile",
      ],
      v2: [
        "indel_length",
        "transitions_and_transversions",
        "genomic_fraction_coverage",
        "chromosome_mean_coverage",
        "mapping_quality_across_reference",
        "coverage_histogram",
        "acgt_content",
        "insert_size_his",
        "mapped_reads_nucleotide_content",
        "mapped_reads_gc_content_disribution",
        "mapped_read_clipping_profile",
      ],
      v3: [
        "indel_length",
        "transitions_and_transversions",
        "genomic_fraction_coverage",
        "chromosome_mean_coverage",
        "mapping_quality_across_reference",
        "coverage_histogram",
        "acgt_content",
        "insert_size_his",
        "mapped_reads_nucleotide_content",
        "mapped_reads_gc_content_disribution",
        "mapped_read_clipping_profile",
      ],
      v4: [
        "indel_length",
        "transitions_and_transversions",
        "genomic_fraction_coverage",
        "chromosome_mean_coverage",
        "mapping_quality_across_reference",
        "coverage_histogram",
        "acgt_content",
        "insert_size_his",
        "mapped_reads_nucleotide_content",
        "mapped_reads_gc_content_disribution",
        "mapped_read_clipping_profile",
      ],
      v5: [
        "indel_length",
        "transitions_and_transversions",
        "genomic_fraction_coverage",
        "chromosome_mean_coverage",
        "mapping_quality_across_reference",
        "coverage_histogram",
        "acgt_content",
        "insert_size_his",
        "mapped_reads_nucleotide_content",
        "mapped_reads_gc_content_disribution",
        "mapped_read_clipping_profile",
      ],
      v6: [
        "indel_length",
        "transitions_and_transversions",
        "genomic_fraction_coverage",
        "chromosome_mean_coverage",
        "mapping_quality_across_reference",
        "coverage_histogram",
        "acgt_content",
        "insert_size_his",
        "mapped_reads_nucleotide_content",
        "mapped_reads_gc_content_disribution",
        "mapped_read_clipping_profile",
      ],
      v7: [
        "indel_length",
        "transitions_and_transversions",
        "genomic_fraction_coverage",
        "chromosome_mean_coverage",
        "mapping_quality_across_reference",
        "coverage_histogram",
        "acgt_content",
        "insert_size_his",
        "mapped_reads_nucleotide_content",
        "mapped_reads_gc_content_disribution",
        "mapped_read_clipping_profile",
      ],
      v8: [
        "indel_length",
        "transitions_and_transversions",
        "genomic_fraction_coverage",
        "chromosome_mean_coverage",
        "mapping_quality_across_reference",
        "coverage_histogram",
        "acgt_content",
        "insert_size_his",
        "mapped_reads_nucleotide_content",
        "mapped_reads_gc_content_disribution",
        "mapped_read_clipping_profile",
      ],
      v9: [
        "indel_length",
        "transitions_and_transversions",
        "genomic_fraction_coverage",
        "chromosome_mean_coverage",
        "mapping_quality_across_reference",
        "coverage_histogram",
        "acgt_content",
        "insert_size_his",
        "mapped_reads_nucleotide_content",
        "mapped_reads_gc_content_disribution",
        "mapped_read_clipping_profile",
      ],
      v10: [
        "indel_length",
        "transitions_and_transversions",
        "genomic_fraction_coverage",
        "chromosome_mean_coverage",
        "mapping_quality_across_reference",
        "coverage_histogram",
        "acgt_content",
        "insert_size_his",
        "mapped_reads_nucleotide_content",
        "mapped_reads_gc_content_disribution",
        "mapped_read_clipping_profile",
      ],
      v11: [
        "indel_length",
        "transitions_and_transversions",
        "genomic_fraction_coverage",
        "chromosome_mean_coverage",
        "mapping_quality_across_reference",
        "coverage_histogram",
        "acgt_content",
        "insert_size_his",
        "mapped_reads_nucleotide_content",
        "mapped_reads_gc_content_disribution",
        "mapped_read_clipping_profile",
      ],
      v12: [
        "indel_length",
        "transitions_and_transversions",
        "genomic_fraction_coverage",
        "chromosome_mean_coverage",
        "mapping_quality_across_reference",
        "coverage_histogram",
        "acgt_content",
        "insert_size_his",
        "mapped_reads_nucleotide_content",
        "mapped_reads_gc_content_disribution",
        "mapped_read_clipping_profile",
      ],
    },
    statistics: {
      v0: [
        "globals",
        "coverage_(inside_of_regions)",
        "mapping_quality_(inside_of_regions)",
        "genebase",
        "insert_size_(inside_of_regions)",
        "mismatches_and_indels_(inside_of_regions)",
        "het_hom_ratio_res",
        "tstv",
      ],
      v1: [
        "globals",
        "coverage_(inside_of_regions)",
        "mapping_quality_(inside_of_regions)",
        "genebase",
        "insert_size_(inside_of_regions)",
        "mismatches_and_indels_(inside_of_regions)",
        "het_hom_ratio_res",
        "tstv",
      ],
      v2: [
        "globals",
        "coverage_(inside_of_regions)",
        "mapping_quality_(inside_of_regions)",
        "genebase",
        "insert_size_(inside_of_regions)",
        "mismatches_and_indels_(inside_of_regions)",
        "het_hom_ratio_res",
        "tstv",
      ],
      v3: [
        "globals",
        "coverage_(inside_of_regions)",
        "mapping_quality_(inside_of_regions)",
        "panelPercentages",
        "insert_size_(inside_of_regions)",
        "genebase",
        "het_hom_ratio_res",
        "dijital_panel",
        "tumor_burden",
        "tstv",
        "mismatches_and_indels_(inside_of_regions)",
      ],
      v4: [
        "globals",
        "coverage_(inside_of_regions)",
        "mapping_quality_(inside_of_regions)",
        "panelPercentages",
        "insert_size_(inside_of_regions)",
        "genebase",
        "het_hom_ratio_res",
        "dijital_panel",
        "tumor_burden",
        "tstv",
        "mismatches_and_indels_(inside_of_regions)",
      ],
      v5: [
        "globals",
        "coverage_(inside_of_regions)",
        "mapping_quality_(inside_of_regions)",
        "panelPercentages",
        "insert_size_(inside_of_regions)",
        "genebase",
        "het_hom_ratio_res",
        "dijital_panel",
        "tumor_burden",
        "tstv",
        "mismatches_and_indels_(inside_of_regions)",
      ],
      v6: [
        "globals",
        "coverage_(inside_of_regions)",
        "mapping_quality_(inside_of_regions)",
        "panelPercentages",
        "insert_size_(inside_of_regions)",
        "genebase",
        "het_hom_ratio_res",
        "dijital_panel",
        "tumor_burden",
        "tstv",
        "mismatches_and_indels_(inside_of_regions)",
      ],
      v7: [
        "globals",
        "coverage_(inside_of_regions)",
        "mapping_quality_(inside_of_regions)",
        "panelPercentages",
        "insert_size_(inside_of_regions)",
        "genebase",
        "het_hom_ratio_res",
        "dijital_panel",
        "tumor_burden",
        "tstv",
        "mismatches_and_indels_(inside_of_regions)",
      ],
      v8: [
        "globals",
        "coverage_(inside_of_regions)",
        "mapping_quality_(inside_of_regions)",
        "panelPercentages",
        "insert_size_(inside_of_regions)",
        "genebase",
        "het_hom_ratio_res",
        "dijital_panel",
        "tumor_burden",
        "tstv",
        "mismatches_and_indels_(inside_of_regions)",
      ],
      v9: [
        "globals",
        "coverage_(inside_of_regions)",
        "mapping_quality_(inside_of_regions)",
        "panelPercentages",
        "insert_size_(inside_of_regions)",
        "genebase",
        "het_hom_ratio_res",
        "dijital_panel",
        "tumor_burden",
        "tstv",
        "mismatches_and_indels_(inside_of_regions)",
      ],
      v10: [
        "globals",
        "coverage_(inside_of_regions)",
        "mapping_quality_(inside_of_regions)",
        "panelPercentages",
        "insert_size_(inside_of_regions)",
        "genebase",
        "het_hom_ratio_res",
        "dijital_panel",
        "tumor_burden",
        "tstv",
        "mismatches_and_indels_(inside_of_regions)",
      ],
      v11: [
        "globals",
        "coverage_(inside_of_regions)",
        "mapping_quality_(inside_of_regions)",
        "panelPercentages",
        "insert_size_(inside_of_regions)",
        "genebase",
        "het_hom_ratio_res",
        "dijital_panel",
        "tumor_burden",
        "tstv",
        "mismatches_and_indels_(inside_of_regions)",
      ],
      v12: [
        "globals",
        "coverage_(inside_of_regions)",
        "mapping_quality_(inside_of_regions)",
        "panelPercentages",
        "insert_size_(inside_of_regions)",
        "genebase",
        "het_hom_ratio_res",
        "dijital_panel",
        "tumor_burden",
        "tstv",
        "mismatches_and_indels_(inside_of_regions)",
      ],
    },
  },
  acnv_bam: {
    visible: true,
    name: "acnv_bam",
    label: "Advanced CNV Bam",
    tabs: {
      statistics: {
        name: "statistics",
        label: "Statistics",
        order: 0,
        component: "",
      },
      cnv: {
        name: "cnv",
        label: "CNV",
        order: 1,
        component: "",
      },
    },
    detailsTabs: {},
    charts: {
      v0: [
        "cnv_diagram",
        "genomic_fraction_coverage",
        "chromosome_based_copy_ratio",
        "chromosome_based_copy_ratio_male_gender",
        "copy_number_copy_ratio",
        "chromosome_mean_coverage",
        "mapping_quality_across_reference",
        "coverage_histogram",
        "acgt_content",
        "insert_size_his",
        "mapped_reads_nucleotide_content",
        "mapped_reads_gc_content_disribution",
        "mapped_read_clipping_profile",
      ],
      v1: [
        "cnv_diagram",
        "genomic_fraction_coverage",
        "chromosome_based_copy_ratio",
        "chromosome_based_copy_ratio_male_gender",
        "copy_number_copy_ratio",
        "chromosome_mean_coverage",
        "mapping_quality_across_reference",
        "coverage_histogram",
        "acgt_content",
        "insert_size_his",
        "mapped_reads_nucleotide_content",
        "mapped_reads_gc_content_disribution",
        "mapped_read_clipping_profile",
      ],
      v2: [
        "cnv_diagram",
        "genomic_fraction_coverage",
        "chromosome_based_copy_ratio",
        "chromosome_based_copy_ratio_male_gender",
        "copy_number_copy_ratio",
        "chromosome_mean_coverage",
        "mapping_quality_across_reference",
        "coverage_histogram",
        "acgt_content",
        "insert_size_his",
        "mapped_reads_nucleotide_content",
        "mapped_reads_gc_content_disribution",
        "mapped_read_clipping_profile",
      ],
      v3: [
        "cnv_diagram",
        "genomic_fraction_coverage",
        "chromosome_based_copy_ratio",
        "chromosome_based_copy_ratio_male_gender",
        "copy_number_copy_ratio",
        "chromosome_mean_coverage",
        "mapping_quality_across_reference",
        "coverage_histogram",
        "acgt_content",
        "insert_size_his",
        "mapped_reads_nucleotide_content",
        "mapped_reads_gc_content_disribution",
        "mapped_read_clipping_profile",
      ],
    },
    statistics: {
      v0: [
        "globals",
        "coverage_(inside_of_regions)",
        "mapping_quality_(inside_of_regions)",
        "insert_size_(inside_of_regions)",
        "het_hom_ratio_res",
        "mismatches_and_indels_(inside_of_regions)",
        "tstv",
        "tumor_burden",
      ],
      v1: [
        "globals",
        "coverage_(inside_of_regions)",
        "mapping_quality_(inside_of_regions)",
        "insert_size_(inside_of_regions)",
        "het_hom_ratio_res",
        "mismatches_and_indels_(inside_of_regions)",
        "tstv",
        "tumor_burden",
      ],
      v2: [
        "globals",
        "coverage_(inside_of_regions)",
        "mapping_quality_(inside_of_regions)",
        "insert_size_(inside_of_regions)",
        "het_hom_ratio_res",
        "mismatches_and_indels_(inside_of_regions)",
        "tstv",
        "tumor_burden",
      ],
      v3: [
        "globals",
        "coverage_(inside_of_regions)",
        "mapping_quality_(inside_of_regions)",
        "insert_size_(inside_of_regions)",
        "het_hom_ratio_res",
        "mismatches_and_indels_(inside_of_regions)",
        "tstv",
        "tumor_burden",
      ],
    },
  },
  fusion: {
    visible: true,
    name: "fusion",
    label: "Fusion",
    tabs: {
      variant_table: {
        name: "variant_table",
        label: "Variant table",
        order: 0,
        component: "",
      },
    },
    detailsTabs: {
      external: {
        name: "external",
        label: "External databases (ClinVar, COSMIC, Phenotype)",
        order: 0,
        component: "",
      },
      igv: {
        name: "igv",
        label: "Genome visualization",
        order: 1,
        component: "",
      },
    },
    charts: {
      v1: [],
    },
    statistics: {
      v1: [],
    },
  },
  duo: {
    visible: true,
    name: "duo",
    label: "Dual Comparative Analyse",
    tabs: {
      variant_table: {
        name: "variant_table",
        label: "Variant table",
        order: 0,
        component: "",
      },
    },
    detailsTabs: {
      main: {
        name: "main",
        label: "Main details",
        order: 0,
        component: "",
      },
      pathogenicity: {
        name: "pathogenicity",
        label: "Pathogenicity scores",
        order: 1,
        component: "",
      },
      population_conservation: {
        name: "population_conservation",
        label: "Population frequencies and conservation scores",
        order: 2,
        component: "",
      },
      external: {
        name: "external",
        label: "External databases (ClinVar, COSMIC, Phenotype)",
        order: 3,
        component: "",
      },
      biomarker: {
        name: "biomarker",
        label: "Biomarker",
        order: 4,
        component: "",
      },
      comment: {
        name: "comments",
        label: "Comments",
        order: 5,
        component: "",
      },
      igv: {
        name: "igv",
        label: "Genome visualization",
        order: 6,
        component: "",
      },
      uniprot: {
        name: "main",
        label: "Uniprot",
        order: 7,
        component: "",
      },
      related_projects: {
        name: "main",
        label: "Related Projects",
        order: 8,
        component: "",
      },
      customize: {
        name: "main",
        label: "Customized Spesific Values",
        order: 9,
        component: "",
      },
    },
    charts: {
      v1: ["indel_length", "transitions_and_transversions"],
      v2: ["indel_length", "transitions_and_transversions"],
      v3: ["indel_length", "transitions_and_transversions"],
      v4: ["indel_length", "transitions_and_transversions"],
      v5: ["indel_length", "transitions_and_transversions"],
      v6: ["indel_length", "transitions_and_transversions"],
      v7: ["indel_length", "transitions_and_transversions"],
      v8: ["indel_length", "transitions_and_transversions"],
      v9: ["indel_length", "transitions_and_transversions"],
      "v10/somatic": ["indel_length", "transitions_and_transversions"],
      v10: ["indel_length", "transitions_and_transversions"],
      v11: ["indel_length", "transitions_and_transversions"],
      "v11/somatic": ["indel_length", "transitions_and_transversions"],
      v12: ["indel_length", "transitions_and_transversions"],
      "v12/somatic": ["indel_length", "transitions_and_transversions"],
      v13: ["indel_length", "transitions_and_transversions"],
      "v13/somatic": ["indel_length", "transitions_and_transversions"],
      v14: ["indel_length", "transitions_and_transversions"],
      "v14/somatic": ["indel_length", "transitions_and_transversions"],
      v15: ["indel_length", "transitions_and_transversions"],
      "v15/somatic": ["indel_length", "transitions_and_transversions"],
      v16: ["indel_length", "transitions_and_transversions"],
      "v16/somatic": ["indel_length", "transitions_and_transversions"],
      v17: ["indel_length", "transitions_and_transversions"],
      "v17/somatic": ["indel_length", "transitions_and_transversions"],
    },
    statistics: {
      v1: ["het_hom_ratio_res", "tstv"],
      v2: ["het_hom_ratio_res", "tstv"],
      v3: ["het_hom_ratio_res", "tstv"],
      v4: ["het_hom_ratio_res", "tstv"],
      v5: ["het_hom_ratio_res", "tstv"],
      v6: ["het_hom_ratio_res", "tstv"],
      v7: ["het_hom_ratio_res", "tstv"],
      v9: ["het_hom_ratio_res", "tstv"],
      "v10/somatic": ["het_hom_ratio_res", "tstv"],
      v10: ["het_hom_ratio_res", "tstv"],
      "v11/somatic": ["het_hom_ratio_res", "tstv"],
      v11: ["het_hom_ratio_res", "tstv"],
      "v12/somatic": ["het_hom_ratio_res", "tstv"],
      v12: ["het_hom_ratio_res", "tstv"],
      "v13/somatic": ["het_hom_ratio_res", "tstv"],
      v13: ["het_hom_ratio_res", "tstv"],
      "v14/somatic": ["het_hom_ratio_res", "tstv"],
      v14: ["het_hom_ratio_res", "tstv"],
      "v15/somatic": ["het_hom_ratio_res", "tstv"],
      v15: ["het_hom_ratio_res", "tstv"],
      "v16/somatic": ["het_hom_ratio_res", "tstv"],
      v16: ["het_hom_ratio_res", "tstv"],
      "v17/somatic": ["het_hom_ratio_res", "tstv"],
      v17: ["het_hom_ratio_res", "tstv"],
    },
  },
  acnv: {
    visible: false,
    name: "acnv",
    label: "Advanced CNV",
    tabs: {
      statistics: {
        name: "statistics",
        label: "Statistics",
        order: 0,
        component: "",
      },
      cnv: {
        name: "cnv",
        label: "CNV",
        order: 1,
        component: "",
      },
    },
    detailsTabs: {},
    charts: {
      v0: [
        "cnv_diagram",
        "genomic_fraction_coverage",
        "chromosome_based_copy_ratio",
        "chromosome_based_copy_ratio_male_gender",
        "copy_number_copy_ratio",
        "chromosome_mean_coverage",
        "mapping_quality_across_reference",
        "coverage_histogram",
        "acgt_content",
        "insert_size_his",
        "mapped_reads_nucleotide_content",
        "mapped_reads_gc_content_disribution",
        "mapped_read_clipping_profile",
      ],
      v1: [
        "cnv_diagram",
        "genomic_fraction_coverage",
        "chromosome_based_copy_ratio",
        "chromosome_based_copy_ratio_male_gender",
        "copy_number_copy_ratio",
        "chromosome_mean_coverage",
        "mapping_quality_across_reference",
        "coverage_histogram",
        "acgt_content",
        "insert_size_his",
        "mapped_reads_nucleotide_content",
        "mapped_reads_gc_content_disribution",
        "mapped_read_clipping_profile",
      ],
      v2: [
        "cnv_diagram",
        "genomic_fraction_coverage",
        "chromosome_based_copy_ratio",
        "chromosome_based_copy_ratio_male_gender",
        "copy_number_copy_ratio",
        "chromosome_mean_coverage",
        "mapping_quality_across_reference",
        "coverage_histogram",
        "acgt_content",
        "insert_size_his",
        "mapped_reads_nucleotide_content",
        "mapped_reads_gc_content_disribution",
        "mapped_read_clipping_profile",
      ],
    },
    statistics: {
      v0: [
        "globals",
        "coverage_(inside_of_regions)",
        "mapping_quality_(inside_of_regions)",
        "insert_size_(inside_of_regions)",
        "het_hom_ratio_res",
        "mismatches_and_indels_(inside_of_regions)",
        "tstv",
        "tumor_burden",
      ],
      v1: [
        "globals",
        "coverage_(inside_of_regions)",
        "mapping_quality_(inside_of_regions)",
        "insert_size_(inside_of_regions)",
        "het_hom_ratio_res",
        "mismatches_and_indels_(inside_of_regions)",
        "tstv",
        "tumor_burden",
      ],
      v2: [
        "globals",
        "coverage_(inside_of_regions)",
        "mapping_quality_(inside_of_regions)",
        "insert_size_(inside_of_regions)",
        "het_hom_ratio_res",
        "mismatches_and_indels_(inside_of_regions)",
        "tstv",
        "tumor_burden",
      ],
      v3: [
        "globals",
        "coverage_(inside_of_regions)",
        "mapping_quality_(inside_of_regions)",
        "insert_size_(inside_of_regions)",
        "het_hom_ratio_res",
        "mismatches_and_indels_(inside_of_regions)",
        "tstv",
        "tumor_burden",
      ],
    },
  },
};
